import React, { useId } from 'react';
import './Logo.css';

// Hand-drawn from the provided reference image (a gradient "N" monogram
// inside an open corner bracket) — vector, not a traced raster, so it has
// no background baked in and scales cleanly at any size.
//
// The bracket is a single continuous path (top-right tip -> top-left
// corner -> bottom-left corner -> bottom-right tip) specifically so it can
// double as a loading indicator: `animated` runs a dash of it chasing
// around that path on a loop, instead of a generic spinner.
export default function Logo({ size = 28, animated = false, className = '' }) {
  // A hardcoded gradient id broke as soon as two Logos render at once
  // (e.g. AuditReport's live preview + its hidden print-doc twin, or the
  // sidebar + a loading state sharing the same content area) — every
  // instance pointed at whichever <linearGradient> happened to be first in
  // the DOM, and jsPDF's html2canvas-based PDF export in particular choked
  // on the duplicate id rather than just picking one, leaving most of the
  // exported page blank. useId() gives each mounted Logo its own id.
  const gradId = `nc-logo-grad-${useId()}`;
  return (
    <svg
      className={`nc-logo${animated ? ' nc-logo--animated' : ''}${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#4EA8F5" />
          <stop offset="55%" stopColor="#6C63F2" />
          <stop offset="100%" stopColor="#B44FE0" />
        </linearGradient>
      </defs>

      <path
        className="nc-logo__bracket"
        d="M78,16 L18,16 L18,84 L78,84"
        stroke={`url(#${gradId})`}
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <polygon points="32,28 40,28 40,72 32,72" fill={`url(#${gradId})`} />
      <polygon points="60,28 68,28 68,72 60,72" fill={`url(#${gradId})`} />
      <polygon points="32,28 40,28 68,72 60,72" fill={`url(#${gradId})`} />
      <polygon points="34,29.5 40,28 68,70 62.5,72" fill="#fff" opacity="0.14" />
    </svg>
  );
}
